/* склонение слов в зависимости от числа */
const createCountFormatter = ({ few, one, two }) => {
  const titles = [one, two, few]
  const cases = [2, 0, 1, 1, 1, 2]
  return function (num) {
    let number = Number(num)
    let result
    if (Number.isInteger(number)) {
      number = Math.abs(number)
      result = titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
    } else {
      result = titles[1]
    }
    return result
  }
};
//для поля
export const formatPeriodCount = createCountFormatter({
  few: "лет",
  one: "год",
  two: "года"
})
//для подписи под дисклеймером
export const formatPeriodCountInSum = createCountFormatter({
  few: " лет",
  one: " года",
  two: " лет"
})
export const formatMoneyCountInSum = createCountFormatter({
  few: " рублей",
  one: " рубля",
  two: " рублей"
})

// Функция для обновления градиента
function updateRange(range) {
  const value = parseFloat(range.value);
  const max = parseFloat(range.max);
  const min = parseFloat(range.min);
  // Проверка на ноль, чтобы избежать деления на ноль
  const normalizedValue = max > min ? (value - min) / (max - min) * 100 : 0;

  range.style.setProperty('--value', `${normalizedValue}%`);
}

function removeLeadingZeros(num) {
  return num.toString().replace(/^0+/, '') || '0';
}

function calculation(calculator) {
  // Ежемесячный доход на пенсии с поправкой на инфляцию
  const endSum = calculator.querySelector('.js-end-sum')
  // Капитал к пенсии с учетом инфляции
  const capital = calculator.querySelector('.js-capital')
  // Желаемый доход на пенсии в месяц
  const startSum = parseInt(calculator.querySelector('.js-start-sum').value.split(' ').join(''))
  // Ваш возраст
  const period1 = parseInt(calculator.querySelector('.js-age').value)
  // Возраст выхода на пенсию
  const period2 = parseInt(calculator.querySelector('.js-retire').value)
  // Ожидаемая доходность в год
  const profit = parseInt(calculator.querySelector('.js-profit').value)
  // Желаемый доход на пенсии в месяц
  const salary = parseInt(calculator.querySelector('.js-salary').value)
  // Срок получения пенсии
  const longliving = parseInt(calculator.querySelector('.js-longliving').value)
  // Инфляция в год
  const inflation = parseInt(calculator.querySelector('.js-inflation').value)
  // Ежемесячная сумма инвестиций
  const payMonth = calculator.querySelector('.js-pay-month')
  const yearVisual = calculator.querySelectorAll(`.js-year-visual`)
  if(yearVisual) {
    yearVisual[0].innerHTML = formatPeriodCount(period1)
    yearVisual[1].innerHTML = formatPeriodCount(period2)
    yearVisual[2].innerHTML = formatPeriodCount(longliving)
  }
  // n - количество периодов накопления
  const nper = (period2 - period1) * 12;
  console.log('Ваш возраст ' + period1);
  console.log('Возраст выхода на пенсию ' + period2);
  console.log('количество периодов накопления ' + nper);
  const sum = salary * Math.pow((1 + inflation/100), (period2 - period1));
  console.log('Ежемесячный доход на пенсии с поправкой на инфляцию ' + sum);
  // Общая сумма капитала, который нужно создать самостоятельно, руб.
  const drob = inflation / 100 / 12
  const fv = sum * (Math.pow((1 + drob), (longliving * 12)) - 1) / drob; // будущая сумма
  console.log('Общая сумма капитала ' + fv);
  // ежемесячная ставка накопления, доли
  const rate = Math.pow((1 + profit/100), 1 / 12) - 1
  console.log('Ожидаемая доходность, % годовых ' + profit);
  console.log('ежемесячная ставка накопления ' + rate);
  // pv - текущая стоимость будущих накоплений
  const prgrob = profit / 100 / 12
  const pv = fv / Math.pow((1 + prgrob), nper)
  // размер ежемесячного взноса (ежемесячная сумма инвестиций)
  let resPayPerMonth = pv * (prgrob * Math.pow((1 + prgrob), nper)) / (Math.pow((1 + prgrob), nper) - 1)
  console.log('ежемесячный взнос ' + resPayPerMonth);
  if (resPayPerMonth < 0) {
    resPayPerMonth = 0;
  }
  if (nper === 0) {
    resPayPerMonth = 0;
  }
  // Ежемесячная сумма инвестиций
  if (fv.toString().includes('e')) {
    payMonth.innerHTML = '∞'
  } else {
    payMonth.innerHTML = Math.round(resPayPerMonth).toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ')
  }
  // Капитал к пенсии с учетом инфляции
  if (fv.toString().includes('e')) {
    capital.innerHTML = '∞'
  } else {
    capital.innerHTML = Math.round(fv).toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ')
  }
  // Ежемесячный доход на пенсии с поправкой на инфляцию
  if (fv.toString().includes('e')) {
    endSum.innerHTML = '∞'
  } else {
    endSum.innerHTML = Math.round(sum).toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ')
  }
}
window.addEventListener(`DOMContentLoaded`, () => {
  let calculator = document.querySelector('.js-calculator')
  let rangeInput = calculator.querySelectorAll('.js-calculator-input')

  calculation(calculator)

  rangeInput.forEach((item) => {
    const inputs = item.querySelectorAll('input')
    const rangeNum = inputs[0]; //текстовый
    const range = inputs[1]; //ползунок

    updateRange(range); // Устанавливаем начальное значение
// Добавляем обработчик события
    range.addEventListener('input', () => updateRange(range));

    new Inputmask({
      mask: "*{0,10}",
      placeholder: '',
      showMaskOnHover: false,
      autoUnmask: true,
      definitions: {
        '*': {
          validator: "[0-9 ]",
          casing: "lower"
        }
      },
    }).mask(inputs[0]);
    //Если покрутили ползунок то и цифру выводим соответствующую
    range.addEventListener(`input`, () => {
      if (range.valueAsNumber) {
        rangeNum.value = range.valueAsNumber;
      } else {
        let min = range.getAttribute('min')
        rangeNum.value = min
      }
      const rangeMax = range.getAttribute('max');
      if (range.getAttribute('max') == 10000000) {
        let step = range.value == 0 ? 10 : parseInt(rangeMax / range.value);
        if (step > 10) {
          step = 35000;
        } else if (step > 5) {
          step = 10000 + ((step - 5) * 5000);
        } else {
          step = 3000 + (step * 2000);
        }
        range.setAttribute('step', step);
      }
      rangeNum.value = rangeNum.value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ')
    });
    //Если вручную ввели цифру то и ползунок надо выставить правильно
    rangeNum.addEventListener(`input`, () => {
      let rangeMax = parseInt(range.max);
      let rangeNumValue = parseInt(rangeNum.value);

      if (rangeNumValue > rangeMax) {
        rangeNum.value = rangeMax;
      }
      range.value = rangeNum.value;
      updateRange(range); // Устанавливаем начальное значение
    });
    rangeNum.addEventListener(`change`, () => {
      let rangeMin = parseInt(range.min);
      let rangeNumValue = parseInt(rangeNum.value);

      if ((!rangeNumValue) || (rangeNumValue < rangeMin)) {
        range.value = rangeMin
        rangeNum.value = rangeMin.toString()
        // Вызов события input
        const inputEvent = new Event('input')
        rangeNum.dispatchEvent(inputEvent)
      } else {
        range.value = rangeNum.value
      }
      rangeNum.value = removeLeadingZeros(rangeNum.value)
      updateRange(range); // Устанавливаем начальное значение
    })
    //пересчёт общих итогов после каждого изменения
    inputs.forEach((input) => {
      input.addEventListener(`input`, () => {
        calculation(calculator)
      })
    })

    rangeNum.addEventListener(`focus`, () => {
      rangeNum.value = ("" + rangeNum.value).split(' ').join('');
    })
    rangeNum.addEventListener(`blur`, () => {
      rangeNum.value = rangeNum.value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    })
  })
  // const blockHover = calculator.querySelector('.js-hover-important-info');
  let events = "click";
  if (window.innerWidth >= 1024) {
    events = "mouseover mouseout";
  }
  events.split(" ").forEach(function (e) {
    // blockHover.addEventListener(e, () => {
    //   blockHover.parentElement.querySelector('.js-hover-block').classList.toggle('hidden-block')
    // })
  })
  //Оперу очень сильно корёжит, лишь бы вставить свой стиль по умолчанию, даже css не перебивается
  let isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  if (isOpera) {
    let ranges = document.querySelectorAll('input[type=range]');
    ranges.forEach(function (e) {
      e.style.background = '#EB5828';
      e.style['-webkit-appearance'] = 'none';
    })
  }
})
